<template>
  <auth-layout>
    <div class="form">
      <div class="form__body">
        <header class="header">
          <SvgBase width="129" height="35">
            <SvgLogo />
          </SvgBase>
        </header>
        <p class="text-body-1 text-grey text-center">
          Для продолжения требуется <br />
          авторизоваться с помощью
          <SvgBase width="80" height="15" view-box="0 0 135 20">
            <SvgLogoLeaderId />
          </SvgBase>
        </p>

        <v-btn :block="true" color="primary" @click="login"> Войти </v-btn>

        <!-- Ссылка на собственную регистрацию временно скрыта:
             вход снова только через Лидер ID -->
        <!-- <p class="text-body-1 text-grey text-center auth-hint">
          Нет учётной записи?
          <router-link to="/registration">Зарегистрироваться</router-link>
        </p> -->

        <p class="text-body-2 text-grey text-start disclaimer">
          Почта технической поддержки:
          <a href="mailto:cabinet-support@nti.fund">cabinet-support@nti.fund</a>
        </p>
      </div>
    </div>
  </auth-layout>
</template>

<script setup>
import { api } from '@/api/Api'
import AuthLayout from '@/layouts/auth'
import SvgBase from '@/components/Svg/SvgBase'
import SvgLogoLeaderId from '@/components/Svg/SvgLogoLeaderId'
import SvgLogo from '@/components/Svg/SvgLogo.vue'

function login() {
  const uri = api.auth().authorize()
  window.open(uri, '_self')
}
</script>

<style lang="scss" scoped>
.form {
  width: 550px;
  display: flex;
  flex-direction: column;
  max-width: 1080px;
  justify-content: flex-start;
  align-items: flex-start;

  &__body {
    display: flex;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.08);
    align-items: center;
    justify-content: flex-start;
    padding: 60px;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    gap: 14px;
    width: 100%;
    background: white;

    // безопасное центрирование: когда контент выше карточки,
    // верх не обрезается, а появляется прокрутка
    > :first-child {
      margin-top: auto;
    }

    > :last-child {
      margin-bottom: auto;
    }

    button {
      max-height: 56px;
      font-size: 18px;
      border-radius: 20px;
      text-transform: uppercase;
    }

    .disclaimer {
      width: 100%;
      max-width: 430px;
      overflow-wrap: anywhere;

      a {
        color: inherit;
        text-decoration: underline;
      }
    }

    .auth-hint a {
      font-size: inherit;
    }

    @media (max-width: 599.95px) {
      padding: 24px 16px 45px;
    }
  }

  @media (max-width: 599.95px) {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
